import React from 'react';
import '../Routes.css';

function About() {
  return (
    <div className="page__container">
      <h1 className="page__heading">About</h1>
    </div>
  );
}

export default About;
